// @flow
import Cookie from '<drivers>/cookie';
import { getFromConfig } from '~/core/state/config';
import url from 'url';

const GET = 'GET';
const PUT = 'PUT';
const DELETE = 'DELETE';
const POST = 'POST';

export function httpGet(
    path: string,
    useToken: boolean = true,
    handleSessionTimeout: boolean = true,
    forceEndpoint: ?string
): Promise<Response> {
    return _fetch(path, GET, _getHeaders(useToken), null, handleSessionTimeout, useToken, forceEndpoint);
}

export function httpPut(
    path: string,
    data: Object = {},
    useToken: boolean = true,
    handleSessionTimeout: boolean = true,
    forceEndpoint: ?string
): Promise<Response> {
    return _fetch(path, PUT, _getHeaders(useToken), data, handleSessionTimeout, useToken, forceEndpoint);
}

export function httpDelete(
    path: string,
    data: Object = {},
    useToken: boolean = true,
    handleSessionTimeout: boolean = true,
    forceEndpoint: ?string
): Promise<Response> {
    return _fetch(path, DELETE, _getHeaders(useToken), data, handleSessionTimeout, useToken, forceEndpoint);
}

export function httpPost(
    path: string,
    data: Object = {},
    useToken: boolean = true,
    handleSessionTimeout: boolean = true,
    forceEndpoint: ?string
): Promise<Response> {
    return _fetch(path, POST, _getHeaders(useToken), data, handleSessionTimeout, useToken, forceEndpoint);
}

////// HELPERS //////

/**
 * Wrapper around fetch object.
 *
 * Error handling works as follows:
 * 		- 500 errors are Beekeeper errors (e.g. missing param, incorrectly formatted param, etc.), and are returned
 * 		  as JSON objects. These will be handled in fetch.then(), which passes them off to _handleError(), which
 * 		  formats them and throws them to the .catch() function of _fetch()'s calling function.
 *
 * 		- 400 errors (e.g. 404 not found) are returned by fetch() in the response object, and so again are handled
 * 		  in fetch.then(), before being thrown by _handleError()
 *
 * 		- Network errors (DNS errors, network down, etc.) are automatically thrown by fetch(), and so must be handled
 * 		  by the .catch() function of _fetch()'s calling function.
 *
 * 		  NOTE: If _fetch's calling function (or *its* calling function) doesn't implement .catch()), the error will
 * 		  be suppressed, but an error message will appear in the console log.
 *
 * @param path
 * @param method
 * @param headers
 * @param bodyData
 * @returns {*|Promise.<TResult>}
 * @private
 */
function _fetch(
    path: string,
    method: 'GET' | 'POST' | 'PUT' | 'DELETE',
    headers: Object = _getHeaders(),
    bodyData: ?Object,
    handleSessionTimeout: boolean,
    useToken: boolean,
    forceEndpoint: ?string
): Promise<Response> {
    const fetchParams: RequestOptions = { method, headers };

    if (bodyData) {
        fetchParams.body = JSON.stringify(bodyData);
    }

    const endpoint = forceEndpoint || (useToken && Cookie.get('endpoint')) || getFromConfig('api');
    const { host, pathname: version = '', port, protocol } = url.parse(endpoint);
    const { pathname: apiPath = '', search } = url.parse(path);

    const apiUrl = url.format({
        host,
        protocol,
        port,
        search,
        pathname: `${version.replace(/\/$/, '')}/${apiPath.replace(/^\//, '')}`
    });

    return fetch(apiUrl, fetchParams);
}

function _getHeaders(useToken: boolean = false): Object {
    const headers: Object = {
        'Content-Type': 'application/json'
    };

    const token: ?string = useToken ? Cookie.get('token') : null;
    if (token) {
        headers.authorization = token;
    }

    return headers;
}



// WEBPACK FOOTER //
// ./src/core/api/helpers/helpers.api.js